import SearchQuestionUpdatesPage from './searchQuestionUpdates'

export { SearchQuestionUpdatesPage }
